import React, { FC } from 'react';
import { UseFieldArrayAppend } from 'react-hook-form';
import { titleize } from 'inflection';

import { AttachmentGroups } from 'buyside/components/presentation/WhitePaperForm/WriteupAndAttachments/writeupAndAttachments';
import AttachmentForm from 'buyside/components/presentation/WhitePaperForm/WriteupAndAttachments/Attachments/AttachmentForm/attachmentForm';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';
import Icon from 'buyside/components/presentation/Icon/icon';

import { WhitePaperFormInput } from 'buyside/util/researchSubmission';

import styles from './attachmentsStyles.scss';

const Attachments: FC<{
  append: UseFieldArrayAppend<WhitePaperFormInput, 'attachments'>;
  attachmentGroups: AttachmentGroups;
}> = ({ append, attachmentGroups }) => (
  <ResearchFormWizardSection title="Attachments">
    <div className={styles.attachmentGroups}>
      {Object.entries(attachmentGroups).map(
        ([researchType, { description, icon, attachmentPreviewIndices }]) => {
          const attachmentPreviews = Object.values(attachmentPreviewIndices);

          return (
            <div key={`${researchType}-attachment-group`} className={styles.attachmentGroup}>
              <div>
                <p>
                  <Icon className={styles.attachmentGroupIcon} type={icon} />
                  <strong>{titleize(researchType)}</strong>
                </p>
                <p>{description}</p>
              </div>
              <div className={styles.attachmentPreviews}>
                {attachmentPreviews}
                <AttachmentForm
                  onSubmitCallback={values => append(values)}
                  researchType={researchType}
                />
              </div>
            </div>
          );
        }
      )}
    </div>
  </ResearchFormWizardSection>
);

export default Attachments;
